import { useState } from "react";
import type { FaqItem } from "@/mocks/site";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="w-full flex items-start justify-between gap-4 py-4 text-left cursor-pointer group"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.question}
                </span>
                <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500">
                  <i className={open ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                </span>
              </button>
            </h3>
            {open && (
              <div className="pb-5 pr-8 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}